import React from 'react';

class InformationCard extends React.Component {
  state = {};

  render() {
    return (
      <div className="container">
        <div className="row-fluid">
          <div className="span6">{this.props.title}</div>
          <div className="span6">{this.props.data}</div>
        </div>
      </div>
    );
  };
}

export default InformationCard;
